import React, { Component, Fragment } from 'react';

import styles from './NavigationBar.css'
import fonts from '../../styles/fonts.css'
import grid from '../../styles/grid.css'
import ThemeToggle from '../theme-toggle/ThemeToggle'

class NavigationBar extends Component {
    render() {
        // Path-based active state. /posts is served by the separate blog app
        // in prod, so this highlight is only visible once the blog shares this
        // navbar; on the main app pathname is "/" and posts renders inactive.
        var postsActive = typeof window !== 'undefined' &&
            window.location && window.location.pathname.indexOf('/posts') === 0;
        var postsClass = [fonts["title"], styles["navbar-social"]];
        if (postsActive) postsClass.push(styles["navbar-social-active"]);

        return (
            <Fragment>
                <div className={grid.container}>
                    <div className={styles.navbar}>
                        <div className={styles["navbar-inner"]}>
                            <div className={styles["navbar-identity"]}>
                                <div className={styles["navbar-photo"]} />
                                <div className={styles["navbar-title"]}>
                                    <div className={styles["navbar-name-row"]}>
                                        <div className={[fonts["title-bold"], styles["navbar-name"]].join(' ')}>
                                            Eugene Trapeznikov
                                        </div>
                                    </div>
                                    <div className={[fonts["title"], styles["navbar-subtitle"]].join(' ')}>
                                        <span className={styles.prompt}>&gt;</span> machine learning engineer
                                    </div>
                                </div>
                            </div>
                            <div className={styles["navbar-actions"]}>
                                <a className={postsClass.join(' ')}
                                   href="/posts">posts</a>
                                <a className={[fonts["title"], styles["navbar-social"]].join(' ')}
                                   href="https://github.com/EugeneTrapeznikov" target="_blank" rel="noopener noreferrer">gthb</a>
                                <a className={[fonts["title"], styles["navbar-social"]].join(' ')}
                                   href="https://www.linkedin.com/in/eugenetrapeznikov/" target="_blank" rel="noopener noreferrer">lnkdn</a>
                                <ThemeToggle />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default NavigationBar;
